import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import axios from "axios";
import { getCookie } from "../jwt/_helpers/cookie";
import { sendAuditEvent, fetchAllStatementIdsForInvoiceCreation } from "../utils/auditTrail";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;
const INVOICE_CONSENT_TERMS = "By confirming, you acknowledge that you have fully reviewed and verified all invoice details, calculations, tax information, recipient data, statements, and amounts. You confirm that all provided information is accurate, legally compliant, and final. The invoice will be issued based solely on your submitted data, and you accept full responsibility for its correctness. Once issued, the invoice cannot be reversed, edited, modified, or cancelled by the User. You further acknowledge and agree that the invoice will be sent via email from the User email address provided by Move Music {secondaryEmail}, and that a copy of the invoice shall be sent to the User's primary email address {primaryEmail} and Move Music's email address (finance@movemusic.io) for record-keeping and compliance purposes. Move Music acts solely as a technical platform and assumes no liability for user-submitted information or any resulting tax, accounting, or legal consequences.";

const getInvoiceIdsFromResponse = payload => {
  if (!payload) return [];

  const directId = payload?.id;
  if (directId !== undefined && directId !== null) return [directId];

  return [];
};

const InvoiceModalConfirm = ({
  openModal,
  setToggleModal,
  title,
  setRedirect,
  setError,
  setSuccess,
  apiURL,
  auditEventType,
  auditRoute,
  auditEntityIds = [],
  auditMetadata = {},
  auditStatementSearch = "",
  auditStatementOrdering = "-created",
  primaryEmail = "",
  secondaryEmail = "",
}) => {
  const tokenAPI = getCookie("token");

  const [requestSent, requestSentSET] = useState(false);
  const dataModal = {};

  const handleSubmit = async () => {
    requestSentSET(true);
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    };

    try {
      const resolvedMetadata = { ...auditMetadata };
      if (auditEventType === 14) {
        const allStatementIds = await fetchAllStatementIdsForInvoiceCreation({
          token: tokenAPI,
          search: auditStatementSearch,
          ordering: auditStatementOrdering,
        });
        resolvedMetadata.statement_ids = allStatementIds;
        resolvedMetadata.consent_terms = INVOICE_CONSENT_TERMS
          .replace("{primaryEmail}", primaryEmail || "")
          .replace("{secondaryEmail}", secondaryEmail || "");
      }

      const response = await axios.post(`${API_URL}${apiURL}/`, dataModal, options);
      if (auditEventType) {
        const finalEntityIds = [response?.data?.id];

        sendAuditEvent({
          token: tokenAPI,
          eventType: auditEventType,
          route: auditRoute || (typeof window !== "undefined" ? window.location.pathname : undefined),
          entityType: "invoice",
          entityIds: finalEntityIds,
          metadata: resolvedMetadata,
        });
      }
      setSuccess(true);
      if (setRedirect) {
        setToggleModal(false);
        setTimeout(() => setRedirect(true), 1000);
      } else {
        setToggleModal(false);
      }
    } catch (err) {
      setToggleModal(false);
      setError(true);
    }
  };
  return (
    <Modal isOpen={openModal} centered={true} size="lg">
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <>
          By confirming, you acknowledge that you have fully reviewed and verified all invoice details, calculations, tax information, recipient data, statements, and amounts.
          <br />
          <br />
          You confirm that all provided information is accurate, legally compliant, and final. The invoice will be issued based solely on your submitted data, and you accept full responsibility for its correctness.
          <br />
          <br />
          Once issued, the invoice cannot be reversed, edited, modified, or cancelled by the User.
          <br />
          <br />
          You further acknowledge and agree that the invoice will be sent via email from the User email address provided by Move Music <strong>{secondaryEmail}</strong>, and that a copy of the invoice shall be sent to the User's primary email address <strong>{primaryEmail}</strong> and Move Music's email address <strong>(finance@movemusic.io)</strong> for record-keeping and compliance purposes.
          <br />
          <br />
          Move Music acts solely as a technical platform and assumes no liability for user-submitted information or any resulting tax, accounting, or legal consequences.
        </>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setToggleModal(false)}>
          Cancel
        </Button>
        <Button color="success" disabled={requestSent} onClick={() => handleSubmit()}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default InvoiceModalConfirm;
